export default __webpack_public_path__ + "static/2145-a1330331a1e72f519536c2f60e3ffb9f.gif";